import React, { createContext,useState,useEffect  } from 'react';
import "./Group.css";
import Deletebutton from '../../../../components/buttons/deletebutton/Deletebutton';
import EditButton from '../../../../components/buttons/editbutton/Editbutton';
import { useNavigate } from 'react-router-dom';
import { post } from '../../../../Script/Session.js';
import { Token } from '../../../../Script/Session.js';
import EditForm from './EditForm/EditForm.jsx';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
const Group = ({item}) => {
    const navigate = useNavigate();
    const [comp, setcomp] = useState(false);

    function edit () {
        setcomp(!comp);
    }
    function deletebutton() {
      let body = {};
      body.name = item.name;
      body.token = Token.get();
      body.action = "delete";
      let response = post(body, "/editGroups");
      if (response == null){
          alert("Fehler beim Löschen der Gruppe");
          return;
      }
      if (response == "LOGOUT"){
          navigate("/");
          return;
      }
      let json = JSON.parse(response);
      if (json.status == "OK"){
          alert("Gruppe erfolgreich gelöscht");
          window.location.reload();
      }
    }

    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
    const [isOpen, setIsOpen] = useState(false);
    const [hoveredit,sethoveredit] = useState(false);
    const [hoverdelete,sethoverdelete] = useState(false);
    const handleClick = (e) => {
        setTimeout(() => {
            console.log(e.clientX + " " + e.clientY);
            setMousePos({ x: "75%", y: e.clientY });
            setIsOpen(true);
            console.log("set open true");
        },5);
      };
    
      useEffect(() => {
        const handleClickOutside = () => {
          if (isOpen) {
            console.log("set outside false");
            setIsOpen(false);
          }
        };
        if (isOpen) {
          document.addEventListener('click', handleClickOutside);
        }
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, [isOpen]);
    return (    
    <>   
    {isOpen && (
                <div
                style={{
                position: 'absolute',
                top: mousePos.y,
                left: mousePos.x,
                backgroundColor: 'white',
                width: '160px',
                boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                borderStyle: 'solid',
                borderColor: 'gray',
                borderWidth: '1px',
                display: 'flex',
                flexDirection: 'column',
                zIndex: 1000,
                }}
            >
                {/* Löschen */}
                <div
                                onMouseEnter={() => sethoveredit(true)}
                                onMouseLeave={() => sethoveredit(false)}
                                onClick={() => edit()}
                style={{
                    height: '45px',
                    backgroundColor: hoveredit ? '#f0f0f0' : 'transparent',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: 'gray',
                    cursor: 'pointer',
                }}
                >
                    <>
                    <BorderColorOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                    <p style={{ margin: 0 }}>Bearbeiten</p>
                    </>

                </div>
                <div
                onMouseEnter={() => sethoverdelete(true)}
                onMouseLeave={() => sethoverdelete(false)}
                onClick={() => deletebutton()}
                style={{
                    height: '45px',
                    backgroundColor: hoverdelete ? '#f0f0f0' : 'transparent',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    color: 'red',
                    cursor: 'pointer',
                }}
                >
                    <>
                    <DeleteOutlineOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                    <p style={{ margin: 0, }}>Löschen</p>
                    </>
                </div>
            </div>
        )}






        <div id="asdasjdklasdkaklsdjlkajdlkasjdklöajsjldk"  style={{width: "100%", height: "90px", backgroundColor:"transparent", display: "flex", alignItems: "center",flexDirection: "row", justifyContent: "space-between"}}>
            <div style={{color: "black",marginLeft: "1.5%"}}>
                <p style={{fontWeight: "bold"}}>{item.name}</p>
                <p style={{marginTop: "-15px"}}>Administrator: {item.isadmin ? "ja": "Nein"}</p>
            </div>
            <div style={{color: "black"}}>
                <p style={{fontWeight: "bold"}}>Berechtigungen: {item.permscount}</p>
                <p style={{marginTop: "-15px"}}>Nutzer mit dieser Funktion: {item.usercount}</p>
            </div>
            <div style={{color: "black"}}>
                <p style={{fontWeight: "bold"}}>Punkte: {item.punkte}</p>
                <p style={{marginTop: "-15px"}}>Hat beschreibung: {item.desc != "<p><br></p>"  ? "ja" : "Nein"}</p>
                <p style={{marginTop: "-15px", color: "#3182ba"}}>Namen Kopieren</p>
            </div>
            <div onClick={handleClick}  style={{color: "black", marginRight: "10.0%"}}>
                <TuneOutlinedIcon/>
            </div>
        </div>

    
     <div className="form-container">
               {comp && <EditForm group={item.name} punkte={item.punkte} desc={item.desc}/>} 
            </div>
    </> 
    )

}
export default Group;